import { ReadinessChat } from "./ReadinessChat";

const assurances = ["One focused question at a time", "Faith-informed, never imposed", "Private details are never required"];

export const ReadinessChatSection = () => (
  <section className="readiness-chat-band relative overflow-hidden py-24 text-[#fdf9f0] md:py-32" data-testid="readiness-chat-section">
    <div className="readiness-shell relative z-10 grid items-center gap-14 lg:grid-cols-12 lg:gap-20">
      <div className="lg:col-span-5">
        <p className="readiness-kicker !text-[#d6aa72]" data-testid="readiness-chat-eyebrow">Guidance in the moment</p>
        <h2 className="mt-7 max-w-xl font-serif text-5xl leading-[0.98] md:text-6xl" data-testid="readiness-chat-section-title">A thoughtful place to begin.</h2>
        <p className="mt-7 max-w-lg text-base leading-8 text-[#d5dfda]" data-testid="readiness-chat-section-copy">
          Reflect on your readiness, make sense of your results, or ask a general question about TENET. The AI guide responds with calm, grounded support.
        </p>
        <ul className="mt-10 space-y-4 border-t border-white/20 pt-8 text-sm text-[#dce4df]" data-testid="readiness-chat-assurances">
          {assurances.map((item, index) => <li key={item} className="flex items-center gap-3" data-testid={`readiness-chat-assurance-${index + 1}`}><span className="h-1.5 w-1.5 rotate-45 bg-[#d6aa72]" />{item}</li>)}
        </ul>
      </div>
      <div className="lg:col-span-7"><ReadinessChat /></div>
    </div>
  </section>
);